import React from "react";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const Carousel = () => {
    const steps = [
        {
          id: 1,
          title: "Upload Your Documents",
          description:
            "Upload your resume and the job description in text or file format to start the analysis.",
          image:
            "https://res.cloudinary.com/danm2mfq5/image/upload/v1736145343/kvei3hg7slwzz4dz9acq.png",
        },
        {
          id: 2,
          title: "Review Your Uploads",
          description:
            "Preview the uploaded files to ensure everything looks perfect before proceeding.",
          image:
            "https://res.cloudinary.com/danm2mfq5/image/upload/v1736145958/bjkirzy2bsviote0vxdo.png",
        },
        {
          id: 3,
          title: "Analyze Missing Keywords",
          description:
            "Our AI-powered engine identifies key missing terms from your resume compared to the job description.",
          image:
            "https://res.cloudinary.com/danm2mfq5/image/upload/v1736144995/qgp2va6unslramqm5uhy.png",
        },
        {
          id: 4,
          title: "Secure Payment",
          description:
            "Choose a plan that fits your needs and proceed with our secure payment gateway.",
          image:
            "https://res.cloudinary.com/danm2mfq5/image/upload/v1736145699/vusxmazt9dqg7zklago9.png",
        },
        {
          id: 5,
          title: "Get Your Results",
          description:
            "View your resume score, detailed suggestions, and a summary of missing keywords to improve your profile.",
          image:
            "https://res.cloudinary.com/danm2mfq5/image/upload/v1735800038/r9s4bb2chryigwfraurq.png",
        },
      ];
      

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="w-4/5 mx-auto py-5">
  <Slider {...settings}>
    {steps.map((step) => (
      <div key={step.id} className="text-center py-5">
        <img
          src={step.image}
          alt={step.title}
          className="w-full max-h-72 object-contain mb-5"
        />
        <h2 className="text-xl font-bold mb-2">{step.title}</h2>
        <p className="text-gray-600">{step.description}</p>
      </div>
    ))}
  </Slider>
</div>

  );
};

export default Carousel;
